export enum EmailVerificationStatusEnum {
  Pending = 'pending',
  Failed = 'failed',
  Delivered = 'delivered',
}
